/**
 * Component Initialization
 *
 * Initializes all interactive components.
 */

import { initNavigation } from './navigation';
import { initForms } from './forms';
import { initBlueprintBorders } from './blueprint-borders';
import { initDarkMode } from './dark-mode';
import { initProgramHighlight } from './program-highlight';

export function initComponents(): void {
  initDarkMode();
  initNavigation();
  initForms();
  initBlueprintBorders();
  initProgramHighlight();
}
